import React, { useContext, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { PaginationComponent } from "../../components";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import RolesTableComponent from "../../components/tables/RolesTableComponent";
import PageLayout from "../../layouts/PageLayout";
import { listRoles } from "../../APIs/RoleRequests";
import { ButtonComponent } from "../../components/elements";
import { useLocation } from "react-router-dom";

export default function RolesListPage() {

    const { t } = useContext(TranslatorContext);
    const [roles, setRoles] = React.useState([]);
    const [pagination, setPagination] = React.useState({});
    const [perPage, setPerPage] = React.useState(10);
    const [searchFilter, setSearchFilter] = React.useState('');

    const location = useLocation();
    const listRolesFunction = (page=1) => {
        listRoles(page,perPage,searchFilter).then((res) => {
            setRoles(res.data.data);
            setPagination(res.data.pagination);
        }).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        listRolesFunction();
    }, [perPage,searchFilter,location]);
    const thead = [t("name"), t("created"), t("action")];

    const handlePageClick = (selected) => {
        listRolesFunction(selected.selected + 1);
    }
    
    const redirectToCreatePage = () => {
        window.location.href = '/role';
    };
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('roles_list')}</h3>
                            <ButtonComponent  className="btn btn-primary m-2" onClick={redirectToCreatePage}>{ t('Create New') }</ButtonComponent>
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        
                        <Row xs={1} sm={2} xl={4}>
                            <Col>
                                <LabelFieldComponent
                                    label={t('show_by')}
                                    option={["10", "20", "50", "100"] }
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange= {(e)=>{
                                        setPerPage(e.target.value);
                                    }}
                                />
                            </Col>
                            
                            
                            <Col>
                                <LabelFieldComponent
                                    type="search"
                                    label={t('search_by')}
                                    placeholder={t('id') + ' / ' + t('name') + ' / ' + t('email') + ' / ' + t('number')}
                                    labelDir="label-col"
                                    fieldSize="w-100 h-md"
                                    onChange={(e) => {
                                            setSearchFilter(e.target.value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <RolesTableComponent 
                            thead={ thead }
                            tbody={ roles }
                            refreshPage={ listRolesFunction }
                        />
                        <PaginationComponent pagination={pagination} handlePageClick={handlePageClick}/>
                    </div>
                </Col>
            </Row>
        </PageLayout>
    );
}